import React from 'react';
import Loader from '../components/common/Loader';
import Menu from '../components/common/Menu';
import Navbar from '../components/common/Navbar';
import Header from '../components/home/Header';
import Services from '../components/home/Services';
import Projects from '../components/home/Projects';
import Footer from '../components/common/Footer';
import FloatingCheckoutButton from '../components/common/FloatingCheckoutButton';
import { Helmet } from 'react-helmet';
import { usePageLoader } from '../hooks/usePageLoader';

const Home: React.FC = () => {
  usePageLoader(); // Hide loader on mount for client-side navigation

  return (
    <>
      <Helmet>
        <title>Metal Fabrication Phoenix AZ | Custom Railings, Gates & Metalwork | Tempe Fabrication</title>
        <meta name="description" content="Professional metal fabrication services in Tempe, Arizona. Custom railings, gates, furniture, signs, and architectural metalwork. Licensed contractor AZROC #359773. Get a free quote today." />
        <meta name="keywords" content="metal fabrication Tempe, custom railings Arizona, metal gates Phoenix, architectural metalwork, steel fabrication Tempe, custom metal furniture Phoenix" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Tempe Fabrication LLC" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Open Graph tags for social media */}
        <meta property="og:title" content="Metal Fabrication Phoenix AZ | Tempe Fabrication" />
        <meta property="og:description" content="Professional metal fabrication services in Tempe, Arizona. Custom railings, gates, furniture, signs, and architectural metalwork. Phoenix." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://tempefab.com" />
        <meta property="og:image" content="https://tempefab.com/home/assets/img/logo.png" />

        {/* Local business schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Tempe Fabrication LLC",
            "image": "https://yourwebsite.com/home/assets/img/logo.png",
            "description": "Professional metal fabrication services in Phoenix, Arizona. Custom railings, gates, furniture, signs, and architectural metalwork.",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Tempe",
              "addressRegion": "AZ",
              "addressCountry": "US"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 33.4484,
              "longitude": -111.9017
            },
            "url": "https://tempefab.com",
            "email": "info@tempefab.com",
            "priceRange": "$$",
            "openingHours": "Mo-Fr 08:00-17:00",
            "serviceArea": {
              "@type": "GeoCircle",
              "geoMidpoint": {
                "@type": "GeoCoordinates",
                "latitude": 33.4484,
                "longitude": -111.9017
              },
              "geoRadius": "50"
            },
            "areaServed": ["Phoenix", "Tempe", "Scottsdale", "Mesa", "Chandler", "Glendale"],
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Metal Fabrication Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Custom Railings"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Metal Gates"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Custom Metal Furniture"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Metal Signs"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Architectural Metalwork"
                  }
                }
              ]
            }
          })}
        </script>

        <link rel="canonical" href="https://tempefab.com" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/home/assets/css/home_1_style.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/home/assets/js/home_1_scripts.js"></script>
      </Helmet>
      <div className="home-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <Header />
          <main>
            <Services />
            <Projects />
          </main>
          <Footer />
        </div>
        <FloatingCheckoutButton />
      </div>
    </>
  );
}

export default Home;
